import { render, staticRenderFns } from "./click2moneyDetailsModal.vue?vue&type=template&id=a3d4d5ba&"
import script from "./click2moneyDetailsModal.vue?vue&type=script&lang=js&"
export * from "./click2moneyDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports